import React, { useState, useEffect, useContext, useMemo } from 'react';


import SimpleTable from '../../components/tables/simpleTable';
import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import SearchFilter from '../../components/filters/search';

import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs, Upload } from 'antd';


import Select from 'react-select';
import { selectStyles } from '../../components/dropDown/selectStyle';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { FiRotateCcw, FiPrinter } from "react-icons/fi";

import { DataContext } from '../../init/getData';

import CompoundProduct from './forms/compound';
import SimpleProduct from './forms/simple';
import SerializedProduct from './forms/serialized';
import ProductionProduct from './forms/production';

import SimpleForm from './simple/simpleForm';
import ServiceForm from './service/serviceForm';
import { isActiveFormatter, isActiveTextFormatter } from '../../components/formatters/defFormatter';
import DragableTable from '../../components/tables/dragableTable';


function Product(props) {

  let { } = props;


  const { devData, userData, settingData, api, categoryOptions, companyId, seasonData, refData, formLanguages, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;

  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);

  



  //Get Data 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['category']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refTable, setRefTable] = useState(true);
  const [filter, setFilter] = useState({ search: '', categoryId: null, type: null, companyId });

  const [showAddSimple, setShowAddSimple] = useState(false);
  const [showAddCompound, setShowAddCompound] = useState(false);
  const [showAddSerialized, setShowAddSerialized] = useState(false);
  const [showAddProduction, setShowAddProduction] = useState(false);
  const [showAddService, setShowAddService] = useState(false);

  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [productUnits, setProductUnits] = useState([]);
  const [productCompounds, setProductCompounds] = useState([]);
  const [category, setCategory] = useState([]);
  const [type, setType] = useState('');
  const [simpleProduct, setSimpleProduct] = useState({});
  const [compoundProduct, setCompoundProduct] = useState({});
  const [importedData, setImportedData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [isDraggable, setIsDraggable] = useState(false);
  const [draggedRows, setDraggedRows] = useState([]);
  const [showSaveButton, setShowSaveButton] = useState(false);



  const table = 'product';
  const title = 'Products';



  const addModal = (type) => {
    if (type == 'simple') {
      setShowAddSimple(!showAddSimple);
    } else
      if (type == 'compound') {
        setShowAddCompound(!showAddCompound);
      } else
        if (type == 'serialized') {
          setShowAddSerialized(!showAddSerialized);
        } else
          if (type == 'production') {
            setShowAddProduction(!showAddProduction);
          } else
            if (type == 'service') {
              setShowAddService(!showAddService);
            }
    setIdRow(null);
    setType(type);
  }

  const editModal = (type, record) => {

    if (type == 'simple') {
      setShowAddSimple(!showAddSimple);
      if (!showAddSimple) {
        setIdRow(record);
      }
    }

    else if (type == 'compound') {
      setShowAddCompound(!showAddCompound);
      if (!showAddCompound) {
        setIdRow(record);  
      }
    }

    else if (type == 'serialized') {
      setShowAddSerialized(!showAddSerialized);
      if (!showAddSerialized) {
        setIdRow(record);
      }
    }

    else if (type == 'production') {
      setShowAddProduction(!showAddProduction);
      if (!showAddProduction) {
        setIdRow(record);
      }
    }

    else if (type == 'service') {
      setShowAddService(!showAddService);
      if (!showAddService) {
        setIdRow(record);
      }
    }
  }





  const refreshTable = () => {
    setRefTable(!refTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }


  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        barcode: item.barcode,
        category: item.category?.name,
        name: item.name,
        unit: item.unit,
        quantity: item.quantity,
        currency: item.currency?.code,
        cost: numberFormatter(item.cost),
        price: numberFormatter(item.price),
        status: isActiveTextFormatter(item.isActive),
        type: item.type,

      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };

  const getExcelScale = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        name: item.name,
        barcode: item.barcode,
        price: numberFormatter(item.price),


      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };

  const idColumn = filter.categoryId
  ? { title: contentLanguages.ID, dataIndex: 'dragId', width: '5%', sorter: (a, b) => a.dragId - b.dragId }
  : { title: contentLanguages.ID, dataIndex: 'id', width: '5%', sorter: (a, b) => a.age - b.age };



  const columnDefs = useMemo(() => [
    { title: contentLanguages.ID, dataIndex: 'id', width: '5%', sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.barcode, dataIndex: 'barcode' },
    { title: contentLanguages.category, dataIndex: 'category', render: (e) => (e?.name) },
    { title: contentLanguages.Name, dataIndex: 'name' },
    { title: contentLanguages.unit, dataIndex: 'unit', width: '5%' },
    { title: contentLanguages.quantity, dataIndex: 'quantity', width: '7%' },
    { title: contentLanguages.Currency, dataIndex: 'currency', width: '7%', render: (e) => (e?.code) },
    { title: contentLanguages.cost, dataIndex: 'cost', width: '7%', render: numberFormatter },
    { title: contentLanguages.price, dataIndex: 'price', width: '7%', render: numberFormatter },
    { title: contentLanguages.Status, dataIndex: 'isActive', render: isActiveFormatter, width: '7%' },
    { title: contentLanguages.Type, dataIndex: 'type', width: '7%' },
    {
      title: contentLanguages.Edt,
      width: '5%',
      render: (_, record) => (
        <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => editModal(record.type, record)} />
      ),
    },
    {
      title: contentLanguages.Trash,
      width: '5%',
      render: (_, record) => (record.isActive ? (
        <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => trashModal(record)} />
      ) : <FcUndo size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => recoverModal(record)} />
      )
    }
  ]);


  const refreshTableFunction = () => {
    setRefTable(!refTable)
  }




 

// Update handleSaveOrder function
const handleSaveOrder = async () => {
  try {
    if (!draggedRows.length) {
      toast.warning('No changes to save');
      return;
    }

    // Prepare data with new dragId values
    const updateData = draggedRows.map((row, index) => ({
      id: row.id,
      dragId: index + 1 // Starting from 1
    }));
    
    const response = await api.post('/product/updateDragIds', {
      products: updateData
    });
    
    if (response.data.status) {
      toast.success('Order saved successfully');
      setDraggedRows([]);
      refreshTable();
    } else {
      toast.error(response.data.message || 'Failed to save order');
    }
  } catch (error) {
    console.error('Error saving order:', error);
    toast.error(error.response?.data?.message || 'Failed to save order');
  }
};





  const tableFooter = (
    <div className="d-flex justify-content-end">
      {showSaveButton && (
        <Button 
          style={{ backgroundColor: 'green', borderColor: 'green' }} 
          onClick={handleSaveOrder}
        >
          Save products Order
        </Button>
      )}
    </div>
  );

  const handleSelectChange = (selectedOption, name) => {
    const newFilter = {
      ...filter,
      [name]: selectedOption?.value,
    };
    
    setFilter(newFilter);
    
   
    const draggable = name === 'categoryId' && selectedOption?.value;
    setIsDraggable(draggable);
    setShowSaveButton(draggable);
    
   
    if (draggable) {
      setDraggedRows([]);
    }
  };

  const handleReorderedData = (newOrderedData) => {
    // Update local state immediately for responsive UI
    setData(prev => ({
      ...prev,
      data: newOrderedData
    }));
    
    // Store the dragged rows to be saved later
    setDraggedRows(newOrderedData);
    setShowSaveButton(true);
  };



  return (
    <div>

      {isLoading &&
        <Loader />
      }

      <div>

        <Row className='g-1 mb-3'>

          <Col md={2}>
            <SearchFilter setFilter={setFilter} />
          </Col>

          <Col md={2}>
            <Select
              styles={selectStyles}
              options={categoryOptions}
              isSearchable={true}
              isClearable={true}
              onChange={(e) => handleSelectChange(e, 'categoryId')}
              value={categoryOptions?.find(option => option.value === filter.categoryId) || []}
              placeholder={'Select Category ... '}
              required
            />
          </Col>

          <Col md={6}>
          </Col>

          <Col md={2} className="d-flex justify-content-end">
            <Button onClick={refreshTableFunction}>
              <FiPrinter size={18} />
            </Button>
            <Button onClick={refreshTableFunction}>
              <FiRotateCcw size={18} />
            </Button>

            <div className='dropDown-btn'>
              <DropdownButton title={formLanguages.Add} size="sm" variant="success" className="custom-dropdown-button">
                {settingData.simpleProduct && (<Dropdown.Item onClick={() => addModal('simple')}>Simple</Dropdown.Item>)}
                {settingData.serializedProduct && (<Dropdown.Item onClick={() => addModal('serialized')}>Serialized</Dropdown.Item>)}
                {settingData.compoundProduct && (<Dropdown.Item onClick={() => addModal('compound')}>Compound</Dropdown.Item>)}
                {settingData.serviceProduct && (<Dropdown.Item onClick={() => addModal('service')}>Service</Dropdown.Item>)}
                {settingData.rawMaterialProduct && (<Dropdown.Item onClick={() => addModal('rawMaterial')}>Raw Material</Dropdown.Item>)}
                {settingData.productionProduct && (<Dropdown.Item onClick={() => addModal('production')}>Production</Dropdown.Item>)}
              </DropdownButton>
            </div>
          </Col>

        </Row>

        {showAddSimple &&
          <SimpleForm
            idRow={idRow}
            showModal={showAddSimple}
            toggleModal={() => addModal('simple')}
            refreshTable={refreshTable}
            type={'simple'}
          />
        }

        {showAddSerialized &&
          <SimpleForm
            idRow={idRow}
            showModal={showAddSerialized}
            toggleModal={() => addModal('serialized')}
            refreshTable={refreshTable}
            type={'serialized'}
          />
        }

        {showAddCompound &&
          <SimpleForm
            idRow={idRow}
            showModal={showAddCompound}
            toggleModal={() => addModal('compound')}
            refreshTable={refreshTable}
            type={'compound'}
          />
        }

        {showAddService &&
          <ServiceForm
            idRow={idRow}
            showModal={showAddService}
            toggleModal={() => addModal('service')}
            refreshTable={refreshTable}
            type={'service'}
          />
        }

        <div className="action-icons">


        </div>

      </div>


      {!isLoading &&


        <SimpleTable
          filter={filter}
          addModal={addModal}
          table={table}
          title={title}
          columnDefs={columnDefs}
          idRow={idRow}
          setIdRow={setIdRow}
          refreshTable={refTable}
          data={data}
          setData={setData}
          tableFooter={tableFooter}
          api={api}
          getExcelData={getExcelData}
          getExcelScale={getExcelScale}
          isDraggable={isDraggable}
          onDragEnd={handleReorderedData}
        />
      }

      {trashModal &&
        <TrashModal
          showModal={showTrashModal}
          toggleModal={trashModal}
          idRow={idRow}
          table={table}
          title={title}
          refreshTable={refreshTable}
          api={api}
          data={{ id: idRow?.id }}
        />
      }

      {recoverModal &&
        <RecoverModal
          showModal={showRecoverModal}
          toggleModal={recoverModal}
          idRow={idRow}
          table={table}
          title={title}
          refreshTable={refreshTable}
          api={api}
          data={{ id: idRow?.id }}
        />
      }

    </div >

  )
}

export default Product;
